// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.header {
  position: sticky;
  top: 0;
  z-index: 5;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  background-color: var(--web-primary-color);
  border-bottom: 1px solid var(--secondary-text-color);
}

.header__left {
  display: inline-flex;
  gap: 32px;
}

.header__btns {
  display: inline-flex;
}

.menu__content {
  height: 100vh;
  width: 316px;
}

.menu__content-body {
  padding: 0 16px 24px 16px;
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: repeat(5, 81px) auto;
}
.menu__content-body button:not(:last-of-type) {
  border-bottom: 1px solid var(--splitter-color);
}
.menu__content-body .menu__content-body-btn {
  position: fixed;
  bottom: 24px;
}
.menu__content-body .menu__content-body-btn .main-button {
  min-height: 41px;
}

.menu__content-splitter {
  width: 100%;
  height: 1px;
  background-color: var(--splitter-color);
}

.menu__content-header {
  display: flex;
  align-items: center;
  padding: 16px;
  gap: 24px;
  border-bottom: 1px solid var(--secondary-text-color);
}
.menu__content-header svg:last-child {
  width: 215px;
  height: 46px;
}

@media only screen and (min-device-width: 320px) {
  .header {
    min-width: 320px;
    height: 72px;
    padding: 0 16px;
  }
  .menu__content-header {
    height: 72px;
  }
}
@media only screen and (min-device-width: 768px) {
  .header {
    min-width: 768px;
    height: 84px;
    padding: 0 40px;
  }
  .menu__content-header {
    height: 84px;
  }
}
@media only screen and (min-device-width: 992px) {
  .header {
    min-width: 922px;
    height: 96px;
    padding: 0 48px;
  }
}
@media only screen and (min-device-width: 1366px) {
  .header {
    min-width: 1366px;
    height: 96px;
    padding: 0 48px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Header/header.scss"],"names":[],"mappings":"AAAA;EACE,gBAAA;EACA,MAAA;EACA,UAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,mBAAA;EACA,0CAAA;EACA,oDAAA;AACF;;AAEA;EACE,oBAAA;EACA,SAAA;AACF;;AAEA;EACE,oBAAA;AACF;;AAEA;EACE,aAAA;EACA,YAAA;AACF;;AACA;EACE,yBAAA;EACA,aAAA;EACA,0BAAA;EACA,wCAAA;AAEF;AADE;EACE,8CAAA;AAGJ;AADE;EACE,eAAA;EACA,YAAA;AAGJ;AADI;EACE,gBAAA;AAGN;;AACA;EACE,WAAA;EACA,WAAA;EACA,uCAAA;AAEF;;AAAA;EACE,aAAA;EACA,mBAAA;EACA,aAAA;EACA,SAAA;EACA,oDAAA;AAGF;AADE;EACE,YAAA;EACA,YAAA;AAGJ;;AACA;EACE;IACE,gBAAA;IACA,YAAA;IACA,eAAA;EAEF;EAAA;IACE,YAAA;EAEF;AACF;AAIA;EACE;IACE,gBAAA;IACA,YAAA;IACA,eAAA;EAFF;EAIA;IACE,YAAA;EAFF;AACF;AAQA;EACE;IACE,gBAAA;IACA,YAAA;IACA,eAAA;EANF;AACF;AASA;EACE;IACE,iBAAA;IACA,YAAA;IACA,eAAA;EAPF;AACF","sourcesContent":[".header {\n  position: sticky;\n  top: 0;\n  z-index: 5;\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: center;\n  background-color: var(--web-primary-color);\n  border-bottom: 1px solid var(--secondary-text-color);\n}\n\n.header__left {\n  display: inline-flex;\n  gap: 32px\n}\n\n.header__btns {\n  display: inline-flex;\n}\n\n.menu__content {\n  height: 100vh;\n  width: 316px;\n}\n.menu__content-body{\n  padding: 0 16px 24px 16px;\n  display: grid;\n  grid-template-columns: 1fr;\n  grid-template-rows: repeat(5, 81px) auto;\n  button:not(:last-of-type) {\n    border-bottom: 1px solid var(--splitter-color);\n  }\n  & .menu__content-body-btn{\n    position: fixed;\n    bottom: 24px;\n\n    & .main-button {\n      min-height: 41px;\n    }\n  }\n}\n.menu__content-splitter{\n  width: 100%;\n  height: 1px;\n  background-color: var(--splitter-color);\n}\n.menu__content-header {\n  display: flex;\n  align-items: center;\n  padding: 16px;\n  gap: 24px;\n  border-bottom: 1px solid var(--secondary-text-color);\n\n  & svg:last-child {\n    width: 215px;\n    height: 46px;\n  }\n\n}\n@media only screen and (min-device-width: 320px) {\n  .header {\n    min-width: 320px;\n    height: 72px;\n    padding: 0 16px;\n  }\n  .menu__content-header {\n    height: 72px;\n  }\n  .menu__content-body{\n    //height: calc(100vh - 72px);\n  }\n}\n\n@media only screen and (min-device-width: 768px) {\n  .header {\n    min-width: 768px;\n    height: 84px;\n    padding: 0 40px;\n  }\n  .menu__content-header {\n    height: 84px;\n  }\n  .menu__content-body{\n    //height: calc(100vh - 84px);\n  }\n}\n\n@media only screen and (min-device-width: 992px) {\n  .header {\n    min-width: 922px;\n    height: 96px;\n    padding: 0 48px;\n  }\n}\n\n@media only screen and (min-device-width: 1366px) {\n  .header {\n    min-width: 1366px;\n    height: 96px;\n    padding: 0 48px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
